import InternalRates from "./internal-rates.json"

export default (selectedRate, selectedTerm) => {
  switch (selectedRate) {
    case "Variable":
      if (selectedTerm === "3") {
        return InternalRates["V3"]
      } else {
        return InternalRates["V5"]
      }
    case "Fixed":
      if (selectedTerm === "3") {
        return InternalRates["F3"]
      } else {
        return InternalRates["F5"]
      }
    default:
      return InternalRates["F5"]
  }
}



// WEBPACK FOOTER //
// ./src/utils/generate-internal-rate.js